import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'idp-options-expander-mach-core',
  standalone: true,
  imports: [NgClass],
  templateUrl: './options-expander-mach-core.component.html',
  styleUrls: ['./options-expander-mach-core.component.scss']
})
export class OptionsExpanderMachCoreComponent {
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  @Input() content = '';
  @Input() isExpanded = false;
  @Output() expandedEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  expandedHandler() {
    this.isExpanded = !this.isExpanded;
    this.expandedEmit.emit(this.isExpanded);
  }
}
